<template>
  <section class="reset-passwor-page">
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
  </section>
</template>

<script>
import ClientService from '@/services/client.service';
import AppResetPasswordModal from '@/components/Modal/ResetPasswordModal';

export default {
  name: 'reset-password-page',
  data() {
    return {
      isLoading: Boolean,
    };
  },
  beforeMount() {
    this.isLoading = true;

    const uuid = this.$route.params.uuid;

    ClientService.verifySolicitation(uuid)
      .then(() => {
        this.$buefy.modal.open({
          parent: this,
          component: AppResetPasswordModal,
          trapFocus: true,
          hasModalCard: true,
          onCancel: this.onCancel,
        });
      })
      .catch(() => {
        this.$buefy.dialog.alert({
          title: 'Solicitação inválida!',
          message:
            'O link que tentou utilizar não é válido ou o tempo para a redefinição da senha expirou. Por favor, tente novamente.',
          type: 'is-danger',
          onConfirm: () => this.$router.push('/'),
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>
<style lang="scss" scoped></style>;
